<script>
import CustomIcon from "./CustomIcon.svelte";

  export let label = 'LABEL';
  export let onRemove = () => {
    console.log(ev);
  };
  export let enableRemove = true;
</script>

<span
  class="px-2 inline-flex text-xs leading-5 mx-1 font-semibold rounded-full border-solid border-2 align-middle border-yellow-500 bg-white text-yellow-500"
>
  {label}
  {#if enableRemove}
    <button
      type="button"
      on:click={onRemove}
      class="shrink-0 mx-1 h-4 w-4 rounded-full inline-flex items-center shadow-none border-yellow-500 self-center	justify-center text-yellow-400 hover:bg-yellow-200 hover:text-yellow-500 focus:outline-none focus:bg-yellow-500 focus:text-white"
    >
      <span class="sr-only">Remove large option</span>
     
      <CustomIcon width="8" height="8" name="badge" color="#EAB308"/>
    </button>
  {/if}
</span>
